import AwesomeSlider from 'react-awesome-slider';
import { User } from '@Types/index';
import { ApprovalsListResponse } from '@Types/api/approvalsList';
import { MAvatar, MButton } from '@Components/Base';
import { ReactComponent as DatePickerIcon } from '@Icons/additional/date-picker.svg';
import { ReactComponent as ChevroneIcon } from '@Icons/additional/chevrone-down.svg';

import { parseDateTime } from '@Utils/transformDateTime';
import { ApprovalActions } from '../components';
import { ApprovalHistoryParams } from '../Approvals';

import commonStyle from '../../common-mobile-styles.module.css';
import styles from './component-styles.module.css';

interface Params {
  taskId: string;
  requestId: number;
  requestTypeId?: string;
}

interface ApprovalsMobileProps {
  essListCounter: number;
  mrListCounter: number;
  activeList: ApprovalsListResponse[];
  userCollection: Map<string, User>;
  handleGoToApprovals: () => void;
  handleESSApprovals: () => void;
  handleMRApprovals: () => void;
  handleApprovalHistory: ({
    requestId,
    requestService,
    requestTypeId,
  }: ApprovalHistoryParams) => void;
  handleApproveTask: ({ taskId, requestId, requestTypeId }: Params) => void;
  handleRejectTask: ({ taskId, requestId, requestTypeId }: Params) => void;
}

const DATE_FORMAT = 'DD/MM/YYYY [at] hh:mm A';

const ApprovalsMobile: React.FC<ApprovalsMobileProps> = ({
  essListCounter = 0,
  mrListCounter = 0,
  activeList,
  userCollection,
  handleGoToApprovals,
  handleESSApprovals,
  handleMRApprovals,
  handleApprovalHistory,
  handleApproveTask,
  handleRejectTask,
}) => {
  return (
    <>
      <div className={commonStyle.header}>
        <div className={commonStyle.caption}>My Approvals</div>
        <div className={commonStyle.link} onClick={handleGoToApprovals}>
          <ChevroneIcon className={commonStyle.chevrone} />
        </div>
      </div>
      <div className={styles.actions}>
        <MButton type="secondary" onClick={handleESSApprovals}>
          Employee Self Service
          <div className={styles.counter}>
            <div className={styles.digits}>{essListCounter}</div>
          </div>
        </MButton>
        <MButton type="secondary" onClick={handleMRApprovals}>
          Material Requisition
          <div className={styles.counter}>
            <div className={styles.digits}>{mrListCounter}</div>
          </div>
        </MButton>
      </div>
      <div>
        <AwesomeSlider
          organicArrows={false}
          bullets
          mobileTouch
          className={commonStyle.mobileSlider}
        >
          {activeList.map((task) => (
            <div key={task.details.id} className={styles.approveItem}>
              <div className={styles.userInfo}>
                <div className={styles.avatar}>
                  <MAvatar size={40} />
                </div>
                <div className={styles.info}>
                  <div className={styles.userCaption}>
                    {
                      userCollection.get(task.variables?.employeeNo?.value)
                        ?.empName
                    }
                  </div>
                  <div className={styles.userOccupation}>
                    {
                      userCollection.get(task.variables?.employeeNo?.value)
                        ?.occupation
                    }
                  </div>
                  <div className={styles.userDescription}>
                    {task.variables.taskType.value}
                  </div>
                </div>
              </div>
              <div className={styles.itemContent}>
                <div className={styles.itemTime}>
                  <div className={styles.dates}>
                    <DatePickerIcon />
                    {parseDateTime(task.details.created, DATE_FORMAT)}
                  </div>
                </div>
                <div className={styles.itemActions}>
                  <MButton
                    type="primary"
                    onClick={() => {
                      handleApproveTask({
                        taskId: task.details.id,
                        requestTypeId: task.variables.taskType.value,
                        requestId: task.variables.recordId?.value,
                      });
                    }}
                  >
                    Approve
                  </MButton>
                  <MButton
                    danger
                    onClick={() => {
                      handleRejectTask({
                        taskId: task.details.id,
                        requestTypeId: task.variables.taskType.value,
                        requestId: task.variables.recordId?.value,
                      });
                    }}
                  >
                    Reject
                  </MButton>
                  <ApprovalActions
                    taskId={task.details?.id}
                    requestTypeId={task.variables.taskType?.value}
                    requestNo={task.variables?.requestNo?.value}
                    requestId={task.variables.recordId?.value}
                    requestService={
                      task.variables.taskType.value === 'ITRequisition'
                        ? task.variables.taskType.value
                        : task.variables.requestService?.value
                    }
                    handleApprovalHistory={handleApprovalHistory}
                    onApprove={() => {
                      handleApproveTask({
                        taskId: task.details.id,
                        requestTypeId: task.variables.taskType.value,
                        requestId: task.variables.recordId?.value,
                      });
                    }}
                    onReject={() => {
                      handleRejectTask({
                        taskId: task.details.id,
                        requestTypeId: task.variables.taskType.value,
                        requestId: task.variables.recordId?.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </AwesomeSlider>
      </div>
    </>
  );
};

export default ApprovalsMobile;
